import { get, isEmpty, isPlainObject } from 'lodash'
import { prepareExpression, prepareQuery } from '../form'
import ExpressionResolver from '../store/modules/form/helpers/expression-resolver-store'
import { CALENDAR_VIEWS, FIELD_TYPES } from '../consts'
import { parseJSON } from './json'

export const DEFAULT_VIEW = 'datepicker'
export const CALENDAR_VIEW = 'calendar'
const DEFAULT_FULL_CALENDAR_OPTIONS = {
  calendarOptions: {
    defaultView: CALENDAR_VIEWS.MONTH,
  },
}

const dateFormat = 'YYYY-MM-DD'
const dateTimeFormat = 'YYYY-MM-DD HH:mm:ss'

const EXPRESSION_TYPE = {
  MIN_EXP: 'minExp',
  MAX_EXP: 'maxExp',
}

export default {
  data() {
    return {
      minExp: '',
      maxExp: '',
      minMaxRefresh: 0,
    }
  },
  computed: {
    formats() {
      const formatsMinExp = get(this.field, 'formats.minExp')
      if (formatsMinExp) {
        this.dateExp(formatsMinExp, EXPRESSION_TYPE.MIN_EXP)
      }
      const formatsMaxExp = get(this.field, 'formats.maxExp')
      if (formatsMaxExp) {
        this.dateExp(formatsMaxExp, EXPRESSION_TYPE.MAX_EXP)
      }
      return this.field.formats
    },
    isCalendarView() {
      return this.datePickerView === CALENDAR_VIEW
    },
    datePickerView() {
      return get(this.field, 'datePickerView', DEFAULT_VIEW)
    },
    calendarProperties() {
      const fieldCalendarOptions = get(this.field, 'calendarOptions')
      if (isPlainObject(fieldCalendarOptions)) {
        return isEmpty(fieldCalendarOptions) ? DEFAULT_FULL_CALENDAR_OPTIONS : fieldCalendarOptions
      }
      const optionsFromField = parseJSON(get(this.field, 'calendarOptions') || '{}', this.field.name)
      return isEmpty(optionsFromField) ? DEFAULT_FULL_CALENDAR_OPTIONS : optionsFromField
    },
  },
  methods: {
    prepareQuery,
    prepareExpression,
    setHours(prop) {
      if (prop === EXPRESSION_TYPE.MIN_EXP) {
        const minValue = new Date(this[prop])
        minValue.setHours(0, 0, 0)
        return moment(minValue).format(dateTimeFormat)
      } else {
        const maxValue = new Date(this[prop])
        maxValue.setHours(23, 59, 59)
        return moment(maxValue).format(dateTimeFormat)
      }
    },
    async dateExp(exp, prop) {
      try {
        const expression = this.prepareExpression(this.prepareQuery(exp))
        this[prop] = await ExpressionResolver.resolve({
          sfRowIndex: this.rowIndex,
          expression,
          namespace: this.$storeNamespace,
        })
        if (this[prop] && get(this.field, 'type') === FIELD_TYPES.DATETIME) {
          this[prop] = this.setHours(prop)
        }
        this.minMaxRefresh++
      } catch (error) {
        console.error(error)
      }
    },
  },
}
